import React from 'react';
import { ThemeProvider , FccLabel, ConfigProvider } from '@kaena1/mm-ui-components';
import {theme} from '@kaena1/mm-ui-theme-v3';
import { BroadbandLabel } from "@kaena1/mm-ui-types";
import style from './style.module.scss';
import capitalizeFirstLetter from '../../../11_functions/_capitalizeFirstLetter';
interface BroadbandLabelProps {
    labelData: string;
}

const BroadbandLabelComponent = ({ labelData }: BroadbandLabelProps) => {
    const labelObj = JSON.parse(labelData);
    const broadbandLabelData = labelObj.labels[0];
         type fees =
      | BroadbandLabel["earlyTerminationFee"]
      | BroadbandLabel["oneTimeFees"]
      | BroadbandLabel["providerMonthlyFees"]; 
      function formatNumber(numberString:string) {
        const number = parseFloat(numberString);
        if (!isNaN(number)) {
          const formattedNumber = number.toFixed(2);
          return formattedNumber;
        }
      }

    const providerMonthlyFees = () => {
        const newArray: Array<{
            description: string;
            price: any;
            
        }> = [];
        const monthlyFees = labelObj.labels[0]?.providerMonthlyFees;
        if (!monthlyFees) return [];
        for (const [key, value] of Object.entries(monthlyFees)) {
          const newObject = {
            description: key,
            price: value
          };
          newArray.push(newObject);
        }
    
        return newArray
      };
      const formatTypicalSpeed = ({ type }: { type: string }) => {
        const speedRange = broadbandLabelData?.typicalSpeed?.[type];
        if (!speedRange?.range) return "N/A";

        const units = type !== "latency" && speedRange.units 
          ? capitalizeFirstLetter(speedRange.units) 
          : speedRange.units || "";

        return `${speedRange.range.join("-")} ${units}`;
      };


      const createFeesMap = (feesObj: fees) => {
        const feesArray = [];
        const feesObj_asserted = feesObj;
        for (const fee in feesObj_asserted) {
          feesArray.push({
            description: fee,
            price: feesObj_asserted[fee],
          });
        }
        return feesArray;
      };

  return (
    <div data-cy='broadband-labels' className={style.broadBandContainer}>
        {broadbandLabelData && 
            <ThemeProvider theme={theme}>
                <ConfigProvider config={{NEXT_PUBLIC_SITE_URL: 'https://qa.mintmobile.com'}}>
                    <FccLabel
                        price={broadbandLabelData.providerMonthlyCost}
                        providerName="Mint Mobile"
                        planName={broadbandLabelData.planName}
                        supportPhone={broadbandLabelData.supportPhone}
                        supportLink={
                          <a href={`${broadbandLabelData.support?.URL}`} target="_blank" rel="noreferrer" >
                            mintmobile.com/
                            <wbr />
                            help-center/
                          </a>
                        }
                        networkManagementPolicyUrl={broadbandLabelData.networkManagementPolicyURL}
                        privacyPolicyUrl={broadbandLabelData.privacyPolicyURL}
                        labelId={broadbandLabelData.labelId}
                        providerMonthlyFees={providerMonthlyFees()}
                        introductoryLength={
                            broadbandLabelData.introOffer
                              ? `${broadbandLabelData.rate?.renewal?.duration}` +
                                " " +
                                `${
                                  broadbandLabelData.rate?.renewal?.duration > 1
                                    ? "Months"
                                    : "Month"
                                }`
                              : undefined
                          }
                        regularMonthlyPrice={broadbandLabelData.providerMonthlyRenewalCost}
                        oneTimeFees={createFeesMap(broadbandLabelData.oneTimeFees)}
                          earlyTerminationFees={createFeesMap(broadbandLabelData.earlyTerminationFee)}
                        typicalDownloadSpeed={formatTypicalSpeed({
                            type: "download",
                          }).toString()}
                          typicalUploadSpeed={formatTypicalSpeed({
                            type: "upload",
                          }).toString()}
                          typicalLatency={formatTypicalSpeed({
                            type: "latency",
                          }).toString()}
                          dataIncludedAmount={
                            broadbandLabelData.data?.included?.amount
                              ? `${broadbandLabelData.data?.included?.amount} ${broadbandLabelData.data?.included?.units}`
                              : ""
                          }
                        dataAdditionalPerAmount={createFeesMap(broadbandLabelData?.data?.additionalDataChargePerGB)}
                        requireContract={broadbandLabelData?.requiresContract === "Y" ? true : false}
                        contractLength={broadbandLabelData?.contractLength}
                        contractLink={broadbandLabelData?.contractLink}
                        governmentTaxes={"Varies by Location"}
                        participatesInAcp={
                            broadbandLabelData?.participatesInAcp === "Y" ? true : false
                        }
                        discountUrl={broadbandLabelData?.discount}
                    />
                </ConfigProvider>
            </ThemeProvider>
        }
    </div>
  )
}
export default BroadbandLabelComponent;